import {createI18nScope} from 'common/i18n/scope';

const __i18nScope = createI18nScope(`common.widgets.date-range-picker.models`, {
  'reports.date-range.disabled.all-events': `All Events queries only allow for {{count}} days of data.`,
  'reports.date-range.disabled.beyond-data-retention-detailed-tooltip': `$t(reports.date-range.disabled.date-beyond-data-retention) Reduce the time range to match your data retention period.`,
  'reports.date-range.disabled.data-history-label': `Data unavailable for selected date`,
  'reports.date-range.disabled.date-beyond-data-retention': `Data is only available from {{date}} onwards.`,
  'reports.date-range.disabled.dau': `DAU queries only allow for {{count}} days of data.`,
  'reports.date-range.disabled.max-days': `This type of query only allows for {{count}} days of data.`,
  'reports.date-range.disabled.max-query-label': `Date range too long`,
  'reports.date-range.exclusion.current-month.menu-item-label': `Current month`,
  'reports.date-range.exclusion.current-month.selected-label': `Excluding current month`,
  'reports.date-range.exclusion.current-quarter.menu-item-label': `Current quarter`,
  'reports.date-range.exclusion.current-quarter.selected-label': `Excluding current quarter`,
  'reports.date-range.exclusion.current-week.menu-item-label': `Current week`,
  'reports.date-range.exclusion.current-week.selected-label': `Excluding current week`,
  'reports.date-range.exclusion.custom.selected-label': `Excluding last {{value}} {{unit}}`,
  'reports.date-range.exclusion.disabled.between-date-range': `Between date ranges are incompatible with exclusion periods.`,
  'reports.date-range.exclusion.disabled.default-dashboard-date-range': `Default date ranges are incompatible with exclusion periods.`,
  'reports.date-range.exclusion.disabled.exclusion-exceeds-date-range': `This exclusion period would exceed the selected date range.`,
  'reports.date-range.exclusion.disabled.missing-multiple-flows-steps': `Excluding incomplete conversion windows requires multiple steps and a conversion window criterion.`,
  'reports.date-range.exclusion.disabled.multiple-metrics-conversion-window': `Excluding incomplete conversion window is only available for a single metric.`,
  'reports.date-range.exclusion.disabled.non-line-incomplete-period': `Excluding incomplete periods is only available for over time analysis (ie line charts).`,
  'reports.date-range.exclusion.disabled.unsupported-conversion-unit': `Excluding incomplete conversion windows is not supported for windows measured in seconds or sessions.`,
  'reports.date-range.exclusion.incomplete-conversion-window.menu-item-label': `Incomplete conversion window`,
  'reports.date-range.exclusion.incomplete-conversion-window.selected-label': `Excluding incomplete conversion window`,
  'reports.date-range.exclusion.incomplete-conversion-window.tooltip': `Excludes dates where the funnel conversion window will not be complete.`,
  'reports.date-range.exclusion.incomplete-period.menu-item-label': `Incomplete periods`,
  'reports.date-range.exclusion.incomplete-period.selected-label': `Excluding incomplete periods`,
  'reports.date-range.exclusion.incomplete-period.tooltip': `Incomplete periods will be excluded based on the selected time unit of the chart. Example: an hour-based chart will exclude the current hour as it is incomplete.`,
  'reports.date-range.exclusion.title': `Exclude`,
  'reports.date-range.exclusion.today.menu-item-label': `Today`,
  'reports.date-range.exclusion.today.selected-label': `Excluding today`,
  'reports.date-range.invalid.inverted-dates': `Date start is after end`,
  'reports.date-range.invalid.inverted-dates-tooltip': `Correct the dates or disable time ranges.`,
  'reports.date-range.presets.1-day': `1D`,
  'reports.date-range.presets.12-months': `12M`,
  'reports.date-range.presets.24-weeks': `24W`,
  'reports.date-range.presets.3-months': `3M`,
  'reports.date-range.presets.30-days': `30D`,
  'reports.date-range.presets.6-months': `6M`,
  'reports.date-range.presets.7-days': `7D`,
  'reports.date-range.presets.96-hours': `96H`,
  'reports.date-range.presets.description.1-day': `Last 1 day`,
  'reports.date-range.presets.description.12-months': `Last 12 months`,
  'reports.date-range.presets.description.24-weeks': `Last 24 weeks`,
  'reports.date-range.presets.description.3-months': `Last 3 months`,
  'reports.date-range.presets.description.30-days': `Last 30 days`,
  'reports.date-range.presets.description.6-months': `Last 6 months`,
  'reports.date-range.presets.description.7-days': `Last 7 days`,
  'reports.date-range.presets.description.96-hours': `Last 96 hours`,
  'reports.date-range.presets.period-to-date.current-month': `Current month`,
  'reports.date-range.presets.period-to-date.current-quarter': `Current quarter`,
  'reports.date-range.presets.period-to-date.current-week': `Current week`,
  'reports.date-range.presets.period-to-date.current-year': `Current year`,
  'reports.date-range.presets.period-to-date.month': `Month to date`,
  'reports.date-range.presets.period-to-date.quarter': `Quarter to date`,
  'reports.date-range.presets.period-to-date.week': `Week to date`,
  'reports.date-range.presets.period-to-date.year': `Year to date`,
  'reports.date-range.presets.previous-period.month': `Previous month`,
  'reports.date-range.presets.previous-period.quarter': `Previous quarter`,
  'reports.date-range.presets.previous-period.week': `Previous week`,
  'reports.date-range.presets.previous-period.year': `Previous year`,
  'reports.date-range.presets.today': `Today`,
  'reports.date-range.presets.tooltip.unit-start': `{{unit}} start is set to {{start}}`,
  'reports.date-range.presets.yesterday': `Yesterday`,
  'reports.date-range.type.before': `before`,
  'reports.date-range.type.between': `between`,
  'reports.date-range.type.ends-on': `ends on`,
  'reports.date-range.type.not-between': `not between`,
  'reports.date-range.type.not-on': `not on`,
  'reports.date-range.type.not-relative-after': `not in the last`,
  'reports.date-range.type.on': `on`,
  'reports.date-range.type.relative-after': `in the last`,
  'reports.date-range.type.relative-before': `before the last`,
  'reports.date-range.type.relative-future': `in the next`,
  'reports.date-range.type.since': `since`,
  'reports.date-range.type.starts-on': `starts on`,
  'reports.day-of-week.friday': `Friday`,
  'reports.day-of-week.monday': `Monday`,
  'reports.day-of-week.next-friday': `Next Friday`,
  'reports.day-of-week.next-monday': `Next Monday`,
  'reports.day-of-week.next-saturday': `Next Saturday`,
  'reports.day-of-week.next-sunday': `Next Sunday`,
  'reports.day-of-week.next-thursday': `Next Thursday`,
  'reports.day-of-week.next-tuesday': `Next Tuesday`,
  'reports.day-of-week.next-wednesday': `Next Wednesday`,
  'reports.day-of-week.saturday': `Saturday`,
  'reports.day-of-week.sunday': `Sunday`,
  'reports.day-of-week.thursday': `Thursday`,
  'reports.day-of-week.tuesday': `Tuesday`,
  'reports.day-of-week.wednesday': `Wednesday`,
  'reports.lift-comparison.previous-period.day': `Previous day`,
  'reports.lift-comparison.previous-period.month': `Previous month`,
  'reports.lift-comparison.previous-period.quarter': `Previous quarter`,
  'reports.lift-comparison.previous-period.units.day': `days`,
  'reports.lift-comparison.previous-period.units.month': `months`,
  'reports.lift-comparison.previous-period.week': `Previous week`,
  'reports.lift-comparison.previous-period.with-value': `Previous {{count}} {{unit}}`,
  'reports.lift-comparison.previous-period.year': `Previous year`,
  'reports.time-unit.day': `Day`,
  'reports.time-unit.day-of-week': `Day of Week`,
  'reports.time-unit.day_other': `Days`,
  'reports.time-unit.hour': `Hour`,
  'reports.time-unit.hour-of-day': `Hour of Day`,
  'reports.time-unit.hour_other': `Hours`,
  'reports.time-unit.minute': `Minute`,
  'reports.time-unit.minute_other': `Minutes`,
  'reports.time-unit.month': `Month`,
  'reports.time-unit.month_other': `Months`,
  'reports.time-unit.quarter': `Quarter`,
  'reports.time-unit.quarter_other': `Quarters`,
  'reports.time-unit.second': `Second`,
  'reports.time-unit.second_other': `Seconds`,
  'reports.time-unit.session': `Session`,
  'reports.time-unit.session_other': `Sessions`,
  'reports.time-unit.week': `Week`,
  'reports.time-unit.week_other': `Weeks`,
  'reports.time-unit.year': `Year`,
  'reports.time-unit.year_other': `Years`,
});

__i18nScope.registerTranslationLoaders({"es": () => import("virtual:i18n-scope/es/common.widgets.date-range-picker.models"), "fr": () => import("virtual:i18n-scope/fr/common.widgets.date-range-picker.models"), "id": () => import("virtual:i18n-scope/id/common.widgets.date-range-picker.models"), "ja": () => import("virtual:i18n-scope/ja/common.widgets.date-range-picker.models"), "ko": () => import("virtual:i18n-scope/ko/common.widgets.date-range-picker.models"), "pt": () => import("virtual:i18n-scope/pt/common.widgets.date-range-picker.models"), "zh-CN": () => import("virtual:i18n-scope/zh-CN/common.widgets.date-range-picker.models"), "zh-TW": () => import("virtual:i18n-scope/zh-TW/common.widgets.date-range-picker.models")});
export default __i18nScope;
